import {getDefaultMiddleware} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

export const sagaMiddleware = createSagaMiddleware();
export const middleware = [
  ...getDefaultMiddleware({thunk: false, serializableCheck: false}),
  sagaMiddleware,
];
